import { HttpErrorResponse } from '@angular/common/http';
import { ViewChildren } from '@angular/core';
import { ElementRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faRefresh, faSignIn, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { AuthenticationService } from '../../services/authentication.serivce';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

  loginForm: FormGroup;
  submitted: boolean = false;
  loginErrorMessage: string;

  icon: IconDefinition = faSignIn;

  showLoginScreen: boolean = true;

  @ViewChild("backgroundImage") public bgImage: ElementRef;


  get f() { return this.loginForm.controls; }

  constructor(private formBuilder: FormBuilder, private auth: AuthenticationService, private router: Router) { }

  ngOnInit() {
    var session = this.auth.getSession();

    //The user is logged in, redirect to homepage
    if (this.auth.isLoggedIn()) {
      var baseUrl = window.location.href.replace(this.router.url, '');
      window.location.replace(baseUrl);
    }


    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
    var img = this.bgImage.nativeElement as HTMLImageElement;
    img.onload = () => { this.backgroundImageOnload(); }
    img.onerror = () => { this.bgError(); }
    img.src = "../../../../assets/images/epc4.jpg";
    if (img.complete) {
      this.showLoginScreen = true;
    }
  }

  backgroundImageOnload() {
    this.showLoginScreen = true;
  }

  bgError() {
    console.log("Error loading background image");
  }

  ngOnDestroy(): void {
    // Need to clean up our observable subscription to avoid memory leaks 
    this.auth.onDestroy();
  }

  onSubmit() {
    this.icon = faRefresh;

    var iconContainer = document.getElementById('iconContainer');
    if (iconContainer) {
      iconContainer.classList.add('rotate');
    }

    this.submitted = true;
    
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.auth.login(this.loginForm.get('username')?.value, this.loginForm.get('password')?.value).subscribe({
      next: (data: any) => {
        if (!data) {

        } else {
          this.auth.setSession(data);

          var session = this.auth.getSession();
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.statusText
        }

        this.loginErrorMessage = errorMsg;
        this.icon = faSignIn;
        iconContainer?.classList.remove('rotate');
        return;
      }
    });
  }

  onReset() {
    this.submitted = false;
    this.loginForm.reset();
  }

  redirectToForgotPasswordPage() : void {
    var baseUrl = window.location.href.replace(this.router.url, '/ForgotPassword');
    window.location.replace(baseUrl);
  }

}
